<script lang="ts">
	import { Tooltip } from '$lib/shared/ui';

	interface Props {
		label: string;
		value: string;
		tooltip?: string | undefined;
		tooltipWidth?: string;
		tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right';
		variant?: 'default' | 'primary' | 'success' | 'warning';
		size?: 'sm' | 'md';
	}

	let {
		label,
		value,
		tooltip = undefined,
		tooltipWidth = 'w-48',
		tooltipPlacement = 'bottom',
		variant = 'default',
		size = 'md'
	}: Props = $props();

	const variantClasses = {
		default: '',
		primary: 'text-primary-500',
		success: 'text-success-500',
		warning: 'text-warning-500'
	};

	const sizeClasses = {
		sm: 'text-xl',
		md: 'text-2xl'
	};

	const labelSizeClasses = {
		sm: 'text-xs',
		md: 'text-sm'
	};
</script>

<div class="card p-4">
	{#if tooltip}
		<Tooltip text={tooltip} placement={tooltipPlacement} width={tooltipWidth}>
			<p class="text-surface-700-300 {labelSizeClasses[size]} underline decoration-dotted">
				{label}
			</p>
		</Tooltip>
	{:else}
		<p class="text-surface-700-300 {labelSizeClasses[size]}">{label}</p>
	{/if}
	<p class="{sizeClasses[size]} font-bold {variantClasses[variant]}">{value}</p>
</div>
